/** Marca «mamá posparto» (medidas_biomecanicas o campo plano). */
export function isPostpartumMom(user) {
  if (!user) return false;
  if (user.soy_mama_posparto === true) return true;
  const m = user.medidas_biomecanicas;
  if (!m || typeof m !== 'object' || Array.isArray(m)) return false;
  return m.soy_mama_posparto === true || m.flags?.soy_mama_posparto === true;
}
